import React, { FC } from 'react';

import { Center, HStack } from '@chakra-ui/react';

import {
  getHighPrivilegeColor,
  renderHighPrivilege,
} from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/utils';

import { getHighPrivilegeLevels } from './utils';

interface PrivilegeBadgesProps {
  levels: string[];
}

/**
 * A badge for each high privilege level, or "None". Uses its own list of
 * levels, since the shared one doesn't know Snowflake's "Permissions
 * management" or "Ownership".
 */
export const PrivilegeBadges: FC<PrivilegeBadgesProps> = ({ levels }) => {
  const high = getHighPrivilegeLevels(levels);
  if (!high.length) return <Center color="gray.400">None</Center>;
  return (
    <Center>
      <HStack spacing={0.5}>
        {high.map(level => (
          <React.Fragment key={level}>
            {renderHighPrivilege(level, getHighPrivilegeColor(level))}
          </React.Fragment>
        ))}
      </HStack>
    </Center>
  );
};
